import { Container, Row, Col, Dropdown } from 'react-bootstrap';
import { Events, News } from '../../../containers';
import { BzChip, BzTab, BzTabs, BzTabsContainer, BzTabsContent, BzDatePicker, BzInputText, BzDropdown, BzToolTip } from '../../../components';
import ContainerBody from './ContainerBody';
import ContainerHeader from './ContainerHeader';
import dayjs from 'dayjs';
import { useDispatch, useSelector } from 'react-redux';
import { announcementsExchange, sectorWiseNews, updateActiveNews, updateActiveNewsTab, updateNewsSearchText } from '../../../redux/actions/news';
import { APP_INFO_PARAMS, SIDE_TRAY_EXPAND_PERCENTAGE } from '../../../utils/global_variables';
import { updateEventsSearchText } from '../../../redux/actions/events';
import useInfiniteScroll from '../../../hooks/useInfiniteScroll';
import { memo, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { getAppInfoData } from '../../../utils/global_functions';
import { _getTabs } from '../../../controllers/news';

const jtenantToken = 1;
const newsItemCount = 15;

const SideNews = ({ sideContentId, setToggleSideContainer, setActiveMenu, isExpanded, setIsExpanded, activeTabKeyRecNewsEvents, ...props }) => {//BT- 112339:Watchlist||Side Tray | Closing functionality: ManasaB: 30/06/23
    const dispatch = useDispatch();

    const events = useSelector(state => state?.events?.events);
    const activeEvent = useSelector(state => state?.events?.activeEvent);
    const eventsDate = useSelector(state => state?.events?.selectedDate);
    const objLoginSession = useSelector(state => state?.auth?.objLoginSession);
    // Hari krishna K: 20-08-2023 News
    const arrHotPursuitData = useSelector(state => state?.news?.arrHotPursuitData);
    const arrNewsData = useSelector(state => state?.news?.arrNewsData);
    const arrAnnouncement = useSelector(state => state?.news?.arrAnnouncement);
    const activeTab = useSelector(state => state?.news?.activeNewsTab);
    const isLimtReached = useSelector(state => state?.news?.isLimtReached);

    const sectorCode = useSelector(state => state?.news?.sectorCode);
    const announcementType = useSelector(state => state?.news?.announcementType);
    const newsSearchText = useSelector(state => state?.news?.newsSearchText);
    const eventsSearchText = useSelector(state => state?.events?.eventsSearchText);
    const newsSector = useSelector(state => state?.news?.newsSector);
    const isEventPending = useSelector(state => state?.events?.isEventPending);

    const nCMOTMode = getAppInfoData(APP_INFO_PARAMS.APP_CMOT_MODE);
    const newsTypes = _getTabs(nCMOTMode, arrAnnouncement, arrNewsData, arrHotPursuitData);

    const eventRef = useRef();
    const newsRef = useRef();

    const [newspageNo, setNewsPageNo] = useState(2);
    const [announcementPageNo, setAnnouncementPageNo] = useState(2);

    const targetDiv = useRef(null);



    const [filterEvents, setFilterEvents] = useState();
    const [isPickerOpen, setIsPickerOpen] = useState(false);

    const [sideNewsEventsActiveTab, setSideNewsEventsActiveTab] = useState('news');

    const filterNewsType = useCallback((newsTypeId) => {
        let objActiveNews = {};
        if (newsTypes?.length > 0) {
            [objActiveNews] = newsTypes.filter(elem => elem.id === newsTypeId);
        } else {
            objActiveNews = {};
        }
        dispatch(updateActiveNews(objActiveNews));
        targetDiv.current.scrollTop = 0;
        dispatch(updateNewsSearchText(""));
        dispatch(updateActiveNewsTab(newsTypeId));
    }, [newsTypes, dispatch]);

    const onDateChange = (date, dateString) => {
        eventRef?.current?.onDateChange(date, dateString);
        setIsPickerOpen(false);
    };

    useEffect(() => {
        if (eventsDate && eventRef?.current?.getSelectedDateWiseEvents) {
            setFilterEvents(eventRef?.current?.getSelectedDateWiseEvents(eventsDate));
        } else { }
    }, [eventsDate, eventRef, events]);

    const dateCellRender = (date) => {
        const dotNotes = eventRef?.current?.getEventsDateForCalender(date);
        if (dotNotes?.length > 0) {
            return (
                <div style={{ position: 'relative' }}>
                    <span>{date?.date()}</span>
                    <div style={{ position: 'absolute', left: '0', right: '0', textAlign: 'center' }}>
                        <div className='dotStyle'></div>
                    </div>
                </div>
            );
        } else {
            return <span>{date?.date()}</span>;
        }
    };

    useEffect(() => {
        if (filterEvents?.length <= 0) {
            dispatch(updateEventsSearchText(""));
            eventRef?.current?.setObjEvent({});
        }
    }, [filterEvents, dispatch]);

    const handlePanelChange = (value, mode) => {
        eventRef?.current?.handlePanelChange(value, mode);
    };

    const updatedDate = useMemo(() => {
        if (eventsDate?.length) {
            const date = dayjs(eventsDate, 'DD-MMM-YYYY');
            return date;
        } else { }
    }, [eventsDate]);

    useEffect(() => {
        if (filterEvents?.length > 0 && activeEvent) {
            eventRef?.current?.getActiveEventsList(filterEvents, activeEvent);
        } else { }
    }, [filterEvents, activeEvent]);

    const handleEventTabs = (eventTab) => {
        eventRef?.current?.handleEventTabs(eventTab);
    };


    const onEventSearchChange = (value) => {
        dispatch(updateEventsSearchText(value));
    };

    // Hari K:04-09-2023 news functionality start

    const filterNewsSectorWise = (newsSectorCode) => {
        newsRef?.current?.filterNewsSectorWise(newsSectorCode);
    };

    const filterAnnouncements = (exchange) => {
        newsRef?.current?.filterAnnouncements(exchange);
    };

    const onSearchChange = (value) => {
        dispatch(updateNewsSearchText(value));

    };

    const objActiveTab = useMemo(() => newsTypes?.filter((each) => each.id === activeTab), [activeTab]);

    const onScroll = () => {
        if (sideNewsEventsActiveTab === "news") {
            if (objActiveTab[0].tabKey === "news" || objActiveTab[0].tabKey === 'announcements') {
                handleScroll();
            } else {
            }
        } else {
        }
    };

    const [isNearBottom, handleScroll] = useInfiniteScroll(targetDiv, 100);

    useEffect(() => {
        if (isNearBottom) {
            if (objActiveTab[0].tabKey === "news" && isLimtReached === false) {
                dispatch(sectorWiseNews(sectorCode, newspageNo, newsItemCount, jtenantToken));
                setNewsPageNo(prev => prev + 1); // Hari K:02-11-2023: BT-107439 :  seting newsPageNo states
            } else { }
            if (objActiveTab[0].tabKey === "announcements" && isLimtReached === false) {
                dispatch(announcementsExchange(announcementType, announcementPageNo, newsItemCount, jtenantToken));
                setAnnouncementPageNo(prev => prev + 1); // Hari K:02-11-2023: BT-107439 :  setting announcementPageNo states
            } else { }
        } else { }
    }, [isNearBottom]);


    // Hari K:04-09-2023 news functionality end
    //Vaibhav Singh: 09-01-24: Fixed search bar issue: Start
    const onEventsSearchChange = (value) => {
        dispatch(updateNewsSearchText(value));
    };
    //Vaibhav Singh: 09-01-24: Fixed search bar issue: End


    const handleClose = () => {
        setIsExpanded(prevState => { return { ...prevState, isTrue: false, containerLength: SIDE_TRAY_EXPAND_PERCENTAGE.ZERO_PERCENT }; });
        setToggleSideContainer(false);
        setActiveMenu({});
    };

    return (
        <>
            {!activeTabKeyRecNewsEvents ?
                <ContainerHeader>
                    <Container fluid className='p-0'>
                        <Row className='g-0 stickysidemenu-top-header bdr-btm p-3'>
                            <Col md={9} className='d-flex justify-content-start align-self-center'>
                                <div className='font-medium font-size5 color-text text-uppercase line-height-1'>NEWS &amp; EVENTS</div>
                                {props.children}
                            </Col>
                            <Col md={3} className='d-flex justify-content-end align-self-center'>
                                <BzToolTip placement={'bottom'} TooltipMsg={`${isExpanded?.isTrue ? "Collapse" : "Expand"}`}>
                                    <div onClick={() => setIsExpanded(prevState => { return { ...prevState, isTrue: !prevState?.isTrue, containerLength: prevState?.isTrue ? SIDE_TRAY_EXPAND_PERCENTAGE?.TWENTY_FIVE_PERCENT : SIDE_TRAY_EXPAND_PERCENTAGE?.FIFTY_PERCENT }; })} className={`icon-16 icon-dark ${isExpanded?.isTrue ? 'icon-collapse' : 'icon-expand'} ms-3`}></div>
                                </BzToolTip>
                                <BzToolTip placement={'bottom'} TooltipMsg={'Close'}>
                                    <div className='icon-16 icon-dark icon-close ms-3' onClick={handleClose}></div>
                                </BzToolTip>
                            </Col>
                        </Row>
                        <Row className='g-0 mt-2 px-3'>
                            <Col>
                                <div className='horizontal-scroll-wrap'>
                                    <BzTabs className='nav nav-tabs'>
                                        <BzTab className='nav-link text-capitalize' isActive={sideNewsEventsActiveTab === 'news'} onClick={() => { setSideNewsEventsActiveTab('news'); }} tabKey='news'>News</BzTab>
                                        <BzTab className='nav-link text-capitalize' isActive={sideNewsEventsActiveTab === 'events'} onClick={() => { setSideNewsEventsActiveTab('events'); }} tabKey='events'>Events</BzTab>
                                    </BzTabs>
                                </div>
                            </Col>
                        </Row>

                        {
                            sideNewsEventsActiveTab === 'news' ?
                                <>
                                    <Row className='g-0 my-2 px-3 align-items-center'>
                                        <Col>
                                            <div className='submenu-wrapper horizontal-scroll-wrap py-1'>
                                                {
                                                    newsTypes?.map((newsType) => (
                                                        <BzChip key={newsType?.id} className={`submenuItem ${newsType?.id === activeTab ? 'active' : null}`} onClick={() => { filterNewsType(newsType?.id); }}>
                                                            {newsType?.name}
                                                        </BzChip>
                                                    ))
                                                }
                                            </div>
                                        </Col>
                                        {isExpanded.isTrue === true && objActiveTab[0].tabKey === 'hot_pursuit' ?
                                            <Col>
                                                <div className='position-relative w-100'>
                                                    <div className='icon-14 icon-search icon-grey search-icon-position'></div>
                                                    <BzInputText value={newsSearchText} onChange={(e) => onSearchChange(e.target.value)} size='sm' placeholder='Search...' type="search" className='p-l-30 font-regular'></BzInputText>
                                                </div>
                                            </Col> : null}
                                    </Row>
                                    {isExpanded.isTrue === false && objActiveTab[0].tabKey === 'hot_pursuit' ?
                                        <Row className='g-0 justify-content-center'>
                                            <Col md={11}>
                                                <div className='position-relative w-100'>
                                                    <div className='icon-14 icon-search icon-grey search-icon-position'></div>
                                                    <BzInputText value={newsSearchText} onChange={(e) => onSearchChange(e.target.value)} size='sm' placeholder='Search...' type="search" className='p-l-30 font-regular'></BzInputText>
                                                </div>
                                            </Col>
                                        </Row>
                                        : null}
                                    <Row className='g-0 px-3 justify-content-between'>
                                        <Col md="auto" className='d-flex align-items-center mb-2'>
                                            {
                                                objActiveTab[0].tabKey === 'news' ?
                                                    <>
                                                        <div className='font-medium font-size2 color-text me-2'>Sector:</div>
                                                        <div className='Bzselect-dropdown'>
                                                            <BzDropdown>
                                                                <Dropdown.Toggle className='btn-default'>
                                                                    {
                                                                        newsSector?.filter(each => each?.SectorCode === sectorCode)?.[0]?.SectorName?.length > 30
                                                                            ?
                                                                            `${newsSector?.filter(each => each?.SectorCode === sectorCode)?.[0]?.SectorName?.slice(0, 30)}...`
                                                                            :
                                                                            newsSector?.filter(each => each?.SectorCode === sectorCode)?.[0]?.SectorName
                                                                    }
                                                                </Dropdown.Toggle>
                                                                <Dropdown.Menu>
                                                                    {
                                                                        newsSector?.length > 0 && newsSector?.map((each, i) => (
                                                                            <Dropdown.Item onClick={e => filterNewsSectorWise(each?.SectorCode)} key={each?.SectorCode} value={each?.SectorCode}>{each.SectorName}</Dropdown.Item>
                                                                        ))
                                                                    }
                                                                </Dropdown.Menu>
                                                            </BzDropdown>
                                                        </div>
                                                    </>
                                                    :
                                                    objActiveTab[0].tabKey === 'announcements' ?
                                                        <>
                                                            <div className='font-medium font-size2 color-text'>Exchange:</div>
                                                            <div className='Bzselect-dropdown ms-2'>
                                                                <BzDropdown>
                                                                    <Dropdown.Toggle className='btn-default'>{announcementType}</Dropdown.Toggle>
                                                                    <Dropdown.Menu>
                                                                        {objLoginSession?.data?.exchanges?.includes('NSE_EQ') || (!objLoginSession?.data?.exchanges?.includes('NSE_CUR') && !objLoginSession?.data?.exchanges?.includes('BSE_EQ') && !objLoginSession?.data?.exchanges?.includes('NSE_CUR')) ? <Dropdown.Item onClick={(e) => filterAnnouncements('NSE')}>NSE</Dropdown.Item> : null}
                                                                        {objLoginSession?.data?.exchanges?.includes('BSE_EQ') ? <Dropdown.Item onClick={(e) => filterAnnouncements('BSE')}>BSE</Dropdown.Item> : null}
                                                                        {objLoginSession?.data?.exchanges?.includes('NSE_CUR') ? <Dropdown.Item onClick={(e) => filterAnnouncements('NSECDS')}>NSECDS</Dropdown.Item> : null}
                                                                    </Dropdown.Menu>
                                                                </BzDropdown>
                                                            </div>
                                                        </>
                                                        : null}
                                        </Col>
                                        {isExpanded.isTrue === true && objActiveTab[0].tabKey !== 'hot_pursuit' ?
                                            <Col md={5}>
                                                <div className='position-relative w-100'>
                                                    <div className='icon-14 icon-search icon-grey search-icon-position'></div>
                                                    <BzInputText value={newsSearchText} onChange={(e) => onSearchChange(e.target.value)} size='sm' placeholder='Search...' type="search" className='p-l-30  font-regular'></BzInputText>
                                                </div>
                                            </Col> : null}
                                    </Row>

                                    {isExpanded.isTrue === false && objActiveTab[0].tabKey !== 'hot_pursuit' ?
                                        <Row className='g-0 justify-content-center'>
                                            <Col md={11}>
                                                <div className='position-relative w-100'>
                                                    <div className='icon-14 icon-search icon-grey search-icon-position'></div>
                                                    <BzInputText value={newsSearchText} onChange={(e) => onEventsSearchChange(e.target.value)} size='sm' placeholder='Search...' type="search" className='p-l-30  font-regular'></BzInputText>
                                                </div>
                                            </Col>
                                        </Row>
                                        : null}

                                </>
                                : (
                                    sideNewsEventsActiveTab === 'events' ?
                                        <>
                                            <Row className='g-0 my-2 px-3 d-flex'>
                                                <Col md='auto'>
                                                    <div className='datepicker-wrap p-0'>
                                                        <BzDatePicker className='form-datepicker-secondary form-control font-medium py-1 px-2' disabled={isEventPending} open={isPickerOpen} setIsPickerOpen={setIsPickerOpen} key={updatedDate} handlePanelChange={handlePanelChange} defaultValue={updatedDate} onDateChange={onDateChange} mode={'date'} dateFormat={"DD-MMM-YYYY"} picker={"date"} selectedDate={updatedDate} dateCellRender={dateCellRender} />
                                                    </div>
                                                </Col>
                                            </Row>
                                            <Row className='g-0 my-2 px-3'>
                                                <Col>
                                                    <div className='submenu-wrapper horizontal-scroll-wrap py-1'>
                                                        {filterEvents?.map((each, i) => (
                                                            <BzChip key={i} className={`submenuItem ${each?.event === activeEvent ? 'active' : ''}`} onClick={() => handleEventTabs(each?.event)}>{each?.event}</BzChip>
                                                        ))}
                                                    </div>
                                                </Col>
                                            </Row>
                                            <Row className='g-0 mt-2 mb-2 px-3'>
                                                <Col md={isExpanded?.isTrue ? 5 : 12}>
                                                    <div className='position-relative w-100'>
                                                        <div className='icon-14 icon-search icon-grey search-icon-position'></div>
                                                        <BzInputText value={eventsSearchText} onChange={(e) => onEventSearchChange(e.target.value)} size='sm' placeholder='Search...' type="search" className='p-l-30  font-regular'></BzInputText>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </>

                                        : null
                                )
                        }
                    </Container>
                </ContainerHeader>
                : null}
            <ContainerBody>
                <div className='sticky-newsevents-height' onScroll={onScroll} ref={targetDiv}>
                    <BzTabsContainer className="h-100" containerClassName="h-100" rowClassname="h-100">
                        <BzTabsContent className="h-100" showDefault={sideNewsEventsActiveTab == 'news' || activeTabKeyRecNewsEvents === 'news'} isActive={sideNewsEventsActiveTab == 'news' || activeTabKeyRecNewsEvents === 'news'} tabKey='news'>
                            <News ref={newsRef} />
                        </BzTabsContent>
                        <BzTabsContent showDefault={sideNewsEventsActiveTab == 'events' || activeTabKeyRecNewsEvents === 'events'} isActive={sideNewsEventsActiveTab == 'events' || activeTabKeyRecNewsEvents === 'events'} tabKey='events'>
                            <Events ref={eventRef} setIsExpanded />
                        </BzTabsContent>
                    </BzTabsContainer>
                </div>
            </ContainerBody>

        </>
    );
};

export default memo(SideNews);
